/**
 * AURALA: Main Product (section) variant buttons
 * Restores button-based variant selection for `sections/main-product.liquid`
 * without changing add-to-cart logic.
 */

(function () {
  'use strict';

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const fmt = window.Shopify.money_with_currency_format || window.Shopify.money_format;
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function parseProductJson(root) {
    const script = root.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function ensureDelegation() {
    if (document.documentElement.dataset.auralaMainProductVariantDelegation === 'true') return;
    document.documentElement.dataset.auralaMainProductVariantDelegation = 'true';

    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('.section-main-product .variant-button');
        if (!btn) return;

        const vs = btn.closest('variant-selects');
        if (!vs) return;

        const form = vs.closest('form');
        const variantInput = form ? form.querySelector('input[name="id"]') : null;
        const submitButton = form ? form.querySelector('[type="submit"]') : null;
        if (!variantInput) return;

        const nextId = parseInt(btn.dataset.variantId, 10);
        if (!nextId || Number.isNaN(nextId)) return;

        e.preventDefault();
        e.stopPropagation();

        // Update hidden variant id
        variantInput.value = String(nextId);

        // Toggle selected states + savings badge highlight
        vs.querySelectorAll('.variant-button').forEach((b) => {
          const id = parseInt(b.dataset.variantId, 10);
          const isSelected = id === nextId;
          b.classList.toggle('variant-button--selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

          const badge = b.querySelector('.variant-savings-badge');
          if (badge) badge.classList.toggle('variant-savings-badge--selected', isSelected);
        });

        // Update price
        const sectionId = vs.dataset.section;
        const priceContainer = sectionId ? document.getElementById(`price-${sectionId}`) : null;
        if (priceContainer) {
          const priceEl = priceContainer.querySelector('.price');
          if (priceEl) {
            const cents = parseInt(btn.dataset.variantPrice || '0', 10);
            const compareCents = parseInt(btn.dataset.variantComparePrice || '0', 10);
            priceEl.textContent = formatMoney(cents);

            let compareEl = priceContainer.querySelector('.compare-price');
            if (compareCents && compareCents > cents) {
              if (!compareEl) {
                compareEl = document.createElement('span');
                compareEl.className = 'compare-price';
                compareEl.style.marginRight = '0.5rem';
                compareEl.style.textDecoration = 'line-through';
                compareEl.style.opacity = '0.65';
                priceContainer.insertBefore(compareEl, priceEl);
              }
              compareEl.textContent = formatMoney(compareCents);
              compareEl.style.display = '';
            } else if (compareEl) {
              compareEl.style.display = 'none';
            }
          }
        }

        // Update availability from product JSON if present
        const productData = parseProductJson(vs);
        if (submitButton && productData && Array.isArray(productData.variants)) {
          const v = productData.variants.find((x) => x && x.id === nextId);
          if (v) submitButton.disabled = !v.available;
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureDelegation);
  } else {
    ensureDelegation();
  }

  document.addEventListener('shopify:section:load', ensureDelegation);
})();


